import TextOptionsQuestionTemplate from '~/pages/anatomyV2/libs/components/TextOptionsQuestionTemplate'
import { TEXT_OPTIONS_CORRECT_ANSWERS } from '~/pages/anatomyV2/libs/textOptionsCorrectAnswers'
import {
  vagusNervePNG,
  vagusNerveWEBP,
} from '~/pages/anatomyV2/vagusNerve/constants'
import { PageId } from '~/shared/constants/pagesConstants'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 4

const OPTIONS = [
  { key: 'heartRaces', i18nKey: 'onboarding.vagusNerve.options.heartRaces' },
  { key: 'heartSlows', i18nKey: 'onboarding.vagusNerve.options.heartSlows' },
  { key: 'both', i18nKey: 'onboarding.vagusNerve.options.both' },
]

const VagusNerveAnatomyV2 = (props: TPageProps) => (
  <TextOptionsQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.vagusNerve.title"
    questionImagePNG={vagusNervePNG}
    questionImageWEBP={vagusNerveWEBP}
    questionImageAlt="Vagus nerve"
    options={OPTIONS}
    correctOptionKey={
      TEXT_OPTIONS_CORRECT_ANSWERS[PageId.VAGUS_NERVE_ANATOMY_V2_1]!
    }
    correctTitleI18nKey="onboarding.vagusNerve.correctTitle"
    correctExplanationI18nKey="onboarding.vagusNerve.correctExplanation"
    incorrectTitleI18nKey="onboarding.vagusNerve.incorrectTitle"
    incorrectExplanationI18nKey="onboarding.vagusNerve.incorrectExplanation"
    question="What happens when your vagus nerve kicks in"
  />
)

export default VagusNerveAnatomyV2
